import InviteRoute from '@/screens/Join/InviteRoute';

export default function OrganizationInviteRoute() {
  return <InviteRoute kind="organization" />;
}
